/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MoarBaseMock, MoarBaseMockInterface } from "../MoarBaseMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "isApprovedOrOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarBaseMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarBaseMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarBaseMock__factory extends ContractFactory {
  constructor(...args: MoarBaseMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "MoarBaseMock";
  }

  deploy(
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MoarBaseMock> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<MoarBaseMock>;
  }
  getDeployTransaction(
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  attach(address: string): MoarBaseMock {
    return super.attach(address) as MoarBaseMock;
  }
  connect(signer: Signer): MoarBaseMock__factory {
    return super.connect(signer) as MoarBaseMock__factory;
  }
  static readonly contractName: "MoarBaseMock";
  public readonly contractName: "MoarBaseMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarBaseMockInterface {
    return new utils.Interface(_abi) as MoarBaseMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarBaseMock {
    return new Contract(address, _abi, signerOrProvider) as MoarBaseMock;
  }
}
